import React from 'react';

import styles from './TypingIndicator.module.css';

// Three bouncing dots shown while Pixel composes a reply. role=status +
// aria-live lets screen readers announce that a response is in progress;
// the dots are decorative (aria-hidden). Animation lives in the CSS module.
export default function TypingIndicator() {
    return (
        <div className={styles.bubble} role="status" aria-live="polite" aria-label="Pixel is typing">
            <div className={styles.dots} aria-hidden="true">
                <span className={styles.dot} />
                <span className={`${styles.dot} ${styles['dot-2']}`} />
                <span className={`${styles.dot} ${styles['dot-3']}`} />
            </div>
        </div>
    );
}
